/**
 * Seed annotations for R1AS — docs/SIM_LAB_ANNOTATE.md
 * Export from sim-lab Annotate → paste here to commit.
 *
 * @type {Array<{
 *   id: string,
 *   slug: string,
 *   kind: 'faucet-hit' | 'faucet-spout' | 'stove-display' | 'note',
 *   stationId: string,
 *   label?: string,
 *   notes?: string,
 *   position: [number, number, number],
 *   normal?: [number, number, number],
 *   userEmail?: string,
 *   createdAt?: string,
 * }>}
 */
export const R1AS_ANNOTATIONS_SEED = [
  {
    id: 'ann_mrsf35t1_f0aup',
    slug: 'r1as',
    kind: 'faucet-hit',
    stationId: 'sink-vanity',
    label: 'bath vanity',
    notes: 'Bath vanity click zone',
    position: [-1.2612796312443189, 1.066365174912369, -3.2644949252933237],
    normal: [
      -0.4039211940444766, 0.8321312656443702, 0.38000687590987464,
    ],
    userEmail: 'jordan.j@buildconstrux.com',
    createdAt: '2026-07-19T23:18:47.845Z',
  },
  {
    id: 'ann_shower_west_hit',
    slug: 'r1as',
    kind: 'faucet-hit',
    stationId: 'shower-west',
    label: 'shower valve',
    notes: 'West shower control — click zone',
    position: [-3.2, 1.17, -2.07],
    normal: [0.85, 0.1, 0.5],
    userEmail: 'jordan.j@buildconstrux.com',
    createdAt: '2026-07-19T23:50:00.000Z',
  },
  {
    id: 'ann_shower_west_spout',
    slug: 'r1as',
    kind: 'faucet-spout',
    stationId: 'shower-west',
    label: 'shower head',
    notes: 'Spray emit under shower head',
    position: [-3.202, 1.93, -2.2],
    normal: [0, -1, 0],
    userEmail: 'jordan.j@buildconstrux.com',
    createdAt: '2026-07-19T23:50:01.000Z',
  },
];
